<template>
  <div class="drawlots">
    <img src="https://img3.quanyou.com.cn/joy/group1/M00/1C/07/rB4ChmOOs2-AK4LeAAw9Ncrcn9U028.gif" alt="">
  </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped> 
  .drawlots {
    img {
      width: 375px;
      height: 666px;
    }
  }
</style>